/** ----------------------------------------
    Interface
 ---------------------------------------- */

import { AppStore } from '@interface/store/App';

/** ----------------------------------------
    State
 ---------------------------------------- */

const getters = {
    getLength: state => {
        return state.cases.data.length;
    },
};

/** ----------------------------------------
    Export State
 ---------------------------------------- */

export default getters